(function () {
  var CART_ICON = '<svg class="btn-cart-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';

  function upgradeButton(btn) {
    if (btn.dataset.animUpgraded) return;
    btn.dataset.animUpgraded = '1';

    var originalHTML = btn.innerHTML;

    btn.innerHTML =
      '<span class="btn-text">' + CART_ICON + originalHTML + '</span>' +
      '<span class="btn-spinner"><span class="btn-spinner__ring"></span>Ajout en cours...</span>' +
      '<span class="btn-success-msg"><span class="btn-success-msg__check">✓</span>Ajouté !</span>';
  }

  function setLoading(btn) {
    btn.classList.add('btn--loading');
    btn.classList.remove('btn--success');
  }

  function setSuccess(btn) {
    btn.classList.remove('btn--loading');
    btn.classList.add('btn--success');
    setTimeout(function () {
      btn.classList.remove('btn--success');
    }, 2200);
  }

  function init() {
    document.querySelectorAll('.product-form__submit:not([name="checkout"])').forEach(upgradeButton);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.product-form__submit:not([name="checkout"])');
      if (!btn || btn.disabled) return;
      if (!btn.dataset.animUpgraded) upgradeButton(btn);
      setLoading(btn);
    });

    document.addEventListener('cart:updated', function () {
      document.querySelectorAll('.product-form__submit.btn--loading').forEach(setSuccess);
    });

    document.addEventListener('product:afterAddToCart', function () {
      document.querySelectorAll('.product-form__submit.btn--loading').forEach(setSuccess);
    });

    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input.url || '');
      var isCartAdd = url.indexOf('/cart/add') !== -1;
      return _fetch.apply(this, arguments).then(function (response) {
        if (isCartAdd && response.ok) {
          setTimeout(function () {
            document.querySelectorAll('.product-form__submit.btn--loading').forEach(setSuccess);
          }, 300);
        }
        return response;
      }).catch(function (err) {
        if (isCartAdd) {
          document.querySelectorAll('.product-form__submit.btn--loading').forEach(function (btn) {
            btn.classList.remove('btn--loading');
          });
        }
        throw err;
      });
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
